// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles-module--wrapper--poKDo","label":"styles-module--label--2apZu"};